import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { JourneyPlannerMenuInitStepDeclaration } from "./Steps/JourneyPlannerMenuInitStep";

export const JourneyPlannerMenuStartupFlow = new FlowDefinition("JourneyPlannerMenuFlow");

JourneyPlannerMenuStartupFlow.addStep(JourneyPlannerMenuInitStepDeclaration);

JourneyPlannerMenuStartupFlow.setStartStep("JourneyPlannerMenuInit_Step");

export const JourneyPlannerMenuStartupStepDefinition = new StepDefinition({
    stepName: "JourneyPlannerMenuFlow",
    stepFlow: JourneyPlannerMenuStartupFlow,
    contextIsolation: false
})
